export enum DownloadItemReportType {
    AGGREGATE_PIE_CHART = 'AGGREGATE_PIE_CHART',
    AGGREGATE_BAR_CHART = 'AGGREGATE_BAR_CHART',
    TABLE = 'TABLE'
}
